export type BundleArtKind = 'one' | 'two' | 'three' | 'stack' | 'pile' | 'pile-x';

export interface Bundle {
  id: string;
  coins: number;
  oldPrice: string;
  price: string;
  save: string;
  art: BundleArtKind;
  productId: string;
  popular?: true;
  best?: true;
}

export const BUNDLES: Bundle[] = [
  { id: 'b1', coins: 120,  oldPrice: '',       price: '$0.99',  save: '',    art: 'one',    productId: 'coins_120' },
  { id: 'b2', coins: 350,  oldPrice: '$2.49',  price: '$1.99',  save: '20%', art: 'two',    productId: 'coins_350' },
  { id: 'b3', coins: 700,  oldPrice: '$4.99',  price: '$3.99',  save: '20%', art: 'three',  productId: 'coins_700' },
  { id: 'b4', coins: 1500, oldPrice: '$9.99',  price: '$7.99',  save: '20%', art: 'stack',  productId: 'coins_1500', popular: true },
  { id: 'b5', coins: 4000, oldPrice: '$19.99', price: '$14.99', save: '25%', art: 'pile',   productId: 'coins_4000', best: true },
  { id: 'b6', coins: 9000, oldPrice: '$39.99', price: '$29.99', save: '25%', art: 'pile-x', productId: 'coins_9000' },
];

// Colors unique to the coin store's visual identity — no equivalent theme token exists.
// All shared tokens (gold, mint, purple, white, gray values) come from useTheme() directly.
export const PALETTE = {
  // Bundle card gradient (deep violet progression; theme.primary is too bright for these fills)
  violetLight: '#7B6CE5',
  violetMid:   '#5840BA',
  violetDark:  '#3E2B8A',
  // Modal background gradient (deeper than theme.background.primary)
  bgTop: '#1F0F30',
  bgMid: '#15091F',
  bgBot: '#0A0410',
  // Wallet chip and card border (dark purples unique to this UI)
  walletChipBg: '#1C0F2E',
  cardBorder:   '#1D0F4D',
  cardShadow:   '#0A0420',
  // Earn section surface (earthy brownish tones; no theme equivalent)
  surface:        '#2A1845',
  surfaceBorder:  '#1F0E03',
  earnIconBorder: '#4A1810',
  earnShadow:     '#2A0E08',
  dropShadow:     '#050203',
  mintInk:        '#062417',
  // Buy button gradient (richer green than theme.secondary / theme.success)
  buyGreen:     '#34D399',
  buyGreenDark: '#059669',
  buyBorder:    '#052E1A',
} as const;

export const SPARKLE_DELAYS = [0, 700, 1300] as const;
export const PARTICLE_COUNT = 22;
export const CONFETTI_COUNT = 36;

// Safety backstop for the purchase blocking overlay. The per-call timeouts in the
// native purchase hooks normally end a transaction well before this; the only way
// to still be "processing" at this point is the user sitting on the OS payment
// sheet (which we deliberately never time out). After this, the overlay reveals a
// neutral "Dismiss" so the UI can never be permanently stranded.
export const PURCHASE_WATCHDOG_MS = 60_000;
